import React from "react";

export const SortIcon = React.forwardRef(({children, onClick, className, divClassName, color = '#757575'} : any, ref: any) => {
    return (
        <div ref={ref} className={divClassName}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 5.625H17M3 9.99374H11.75M3 14.375H6.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {children}
        </div>
    )
});